export interface ShowPanelBaseInput {
  showGranularity: boolean
  /** compare.mode, or null when the page renders no compare control. */
  compareMode: string | null
  /** FU-f (operator 2026-06-11: EXPOSE): registry-derived — the page's tile set includes
   *  dynamics_panels, where sub-period panels and compare rows legitimately coexist. */
  panelBearing: boolean
  dots: number
  windowBuckets: number
  multiTfActive: boolean
}

/** Row 15-light visibility, FU-f amended: compare suppresses the checkbox EXCEPT on
 *  panel-bearing pages. An inapplicable URL-carried panel_base stays silently inert
 *  (state-level gate, unchanged). */
export function shouldShowPanelBase(i: ShowPanelBaseInput): boolean {
  return (
    i.showGranularity &&
    (i.compareMode === null || i.compareMode === 'off' || i.panelBearing) &&
    i.dots < i.windowBuckets &&
    !i.multiTfActive
  )
}
